export { MockGeocodeStrategy } from './mock.geocode-strategy';
